<script setup lang="ts">
import AdminUserPerformanceProfile from "@/components/profile/AdminUserPerformanceProfile.vue";

definePage({
  meta: {
    permissionKey: "page.users.profile",
  },
});

const route = useRoute("users-id-profile");

const userId = computed(() => {
  const value = route.params.id;
  return decodeURIComponent(Array.isArray(value) ? String(value[0] ?? "") : String(value ?? ""));
});
</script>

<template>
  <AdminUserPerformanceProfile :user-id="userId" />
</template>
